import { FeedbackTag, Tag } from '@/components/ui/tag';

import { ausschreibungStatus, AusschreibungStatus } from '../../dtos';

export const ausschreibungStatusLabelsShort: Record<AusschreibungStatus, string> = {
  [ausschreibungStatus.KEINE_AUSSCHREIBUNG]: '-',
  [ausschreibungStatus.AUSSCHREIBUNGSENTWURF_GELOESCHT]: 'AS gelöscht',
  [ausschreibungStatus.AUSSCHREIBUNG_VEROEFFENTLICHT]: 'AS veröffentlicht',
  [ausschreibungStatus.AUSSCHREIBUNG_BEENDET]: 'AS beendet',
  [ausschreibungStatus.AUSSCHREIBUNG_ABGEBROCHEN]: 'AS abgebrochen',
  [ausschreibungStatus.ANGEBOT_VEROEFFENTLICHT]: 'AG veröffentlicht',
  [ausschreibungStatus.ANGEBOT_BEENDET]: 'AG beendet',
  [ausschreibungStatus.VERTRAG_STORNIERT]: 'Vertrag storniert',
  [ausschreibungStatus.ANGEBOTSENTWURF_GELOESCHT]: 'AGE gelöscht',
};

export const ausschreibungStatusLabels: Record<AusschreibungStatus, string> = {
  [ausschreibungStatus.KEINE_AUSSCHREIBUNG]: 'Keine Ausschreibung',
  [ausschreibungStatus.AUSSCHREIBUNGSENTWURF_GELOESCHT]: 'Ausschreibungsentwurf gelöscht',
  [ausschreibungStatus.AUSSCHREIBUNG_VEROEFFENTLICHT]: 'Ausschreibung veröffentlicht',
  [ausschreibungStatus.AUSSCHREIBUNG_BEENDET]: 'Ausschreibung beendet',
  [ausschreibungStatus.AUSSCHREIBUNG_ABGEBROCHEN]: 'Ausschreibung abgebrochen',
  [ausschreibungStatus.ANGEBOT_VEROEFFENTLICHT]: 'Angebot veröffentlicht',
  [ausschreibungStatus.ANGEBOT_BEENDET]: 'Angebot beendet',
  [ausschreibungStatus.VERTRAG_STORNIERT]: 'Vertrag storniert',
  [ausschreibungStatus.ANGEBOTSENTWURF_GELOESCHT]: 'Angebotsentwurf gelöscht',
};

type AusschreibungStatusTagProps = {
  status: AusschreibungStatus;
  shortenedLabel?: boolean;
};

export const AusschreibungStatusTag = ({ status, shortenedLabel = false }: AusschreibungStatusTagProps) => {
  const label = shortenedLabel ? ausschreibungStatusLabelsShort[status] : ausschreibungStatusLabels[status];
  const title = shortenedLabel ? ausschreibungStatusLabels[status] : '';

  if (status === ausschreibungStatus.VERTRAG_STORNIERT) {
    return <FeedbackTag feedback="error" variant="strong" label={label} title={title} />;
  }

  return <Tag variant="brandSubtle" className="text-primary" label={label} title={title} />;
};
